import { TypographyV3 } from '@jouzen/ecom-components';
import type { RichTranslationValues } from 'next-intl';
import { useTranslations } from 'next-intl';

interface MembershipAccordionContentProps {
  readonly contentMsgKey: string;
  readonly dataCy?: string;
  readonly values?: RichTranslationValues;
}

const MembershipAccordionContent = ({
  contentMsgKey,
  values,
  dataCy,
}: MembershipAccordionContentProps) => {
  const t = useTranslations();
  const content = t.rich(contentMsgKey, values);
  return (
    <TypographyV3
      color={'light'}
      className="text-sm lg:text-xl"
      data-cy={dataCy}
    >
      {content}
    </TypographyV3>
  );
};
export default MembershipAccordionContent;
